import { ListenerMiddlewareInstance } from '@reduxjs/toolkit';
import { rootReducer } from '../../reducers';
import { invalidateRequestWizardActivitiesExpenses } from '../buyer-da-tool-request-wizard/api';
import { addMoreServicesCompletedMatcher } from '../restApi/secured/requestCaseApi';

export const registerRequestCaseListeners = (
  listenerMiddleware: ListenerMiddlewareInstance<ReturnType<typeof rootReducer>>
) => {
  listenerMiddleware.startListening({
    matcher: addMoreServicesCompletedMatcher,
    effect: (_action, { dispatch }) => {
      dispatch(invalidateRequestWizardActivitiesExpenses());
    }
  });
};
